module.exports = __webpack_public_path__ + "images/31556732f4ca542952ba6fac8dad1121-Roboto-MediumItalic.svg";